import { Box, Modal, Typography, useTheme } from '@mui/material';
import { FiBox, FiDatabase } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import DataSet from 'containers/Business/Setting/DataSet';
import RetrievalTesting from 'containers/Business/Setting/RetrievalTesting';
import { IoClose } from 'react-icons/io5';

export default function KnowledgeForm() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { knowledgeBaseId } = useParams();

  const [knowledgeBase, setKnowledgeBaseTab] = useState('dataset');

  return (
    <Modal
      open={true}
      onClose={() => navigate(-1)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h6'>{knowledgeBaseId ? 'Edit' : 'Create'} Knowledge Base</Typography>
          <Box sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
            <IoClose />
          </Box>
        </Box>
        <Box mt={2}>
          <Box
            display='flex'
            alignItems='center'
            gap={2}
            bgcolor='#fff'
            borderRadius={1}
            sx={{ width: 'fit-content' }}
            mb={3}
          >
            <Box
              display='flex'
              alignItems='center'
              gap={1}
              color={knowledgeBase === 'dataset' ? theme.palette.primary.main : ''}
              padding='8px 24px'
              sx={{
                borderRadius: '8px',
                bgcolor: knowledgeBase === 'dataset' ? theme.palette.primary.light : '',
                cursor: 'pointer'
              }}
              onClick={() => setKnowledgeBaseTab('dataset')}
            >
              <FiDatabase />
              <Typography>Dataset</Typography>
            </Box>

            <Box
              display='flex'
              alignItems='center'
              gap={1}
              color={knowledgeBase === 'retrieval' ? theme.palette.primary.main : ''}
              padding='8px 24px'
              sx={{
                borderRadius: '8px',
                bgcolor: knowledgeBase === 'retrieval' ? theme.palette.primary.light : '',
                cursor: 'pointer'
              }}
              onClick={() => setKnowledgeBaseTab('retrieval')}
            >
              <FiBox />
              <Typography>Retrieval Testing</Typography>
            </Box>
          </Box>
          {knowledgeBase === 'dataset' && <DataSet isRenderInModal={true} />}
          {knowledgeBase === 'retrieval' && <RetrievalTesting isRenderInModal={true} />}
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#F8F9FA',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  height: 700,
  width: {
    xs: '90%',
    sm: 400,
    md: 600,
    lg: 1000
  }
};
